<template>
  <div ref="pageComBox" class="NewCustomer page_wrapper">
    <div ref="otherBox">
      <!-- <Params ref="params" publicPool remarkCount showTeam @search="onSearch" /> -->
      <ParamsDialogVue
        ref="params"
        publicPool
        remarkCount
        showTeam
        :visible.sync="visible"
        :personList="personList"
        @search="onSearch"
      />

      <el-row type="flex" justify="space-between" class="mb-3">
        <el-col :xs="12">
          <div class="flex">
            <el-button
              type="primary"
              size="small"
              :disabled="assistDisabled"
              @click="joininPublicPool"
              >加入公共池</el-button
            >
            <el-popover
              ref="popover"
              placement="bottom-start"
              width="400"
              trigger="click"
              class="mr-4 ml-4"
            >
              <div class="treeContent" v-loading="assistLoading">
                <div class="treeWrapper">
                  <el-tree
                    ref="tree"
                    :data="personList"
                    :props="props"
                    node-key="id"
                    show-checkbox
                    default-expand-all
                    @check="handleCheckChange"
                  >
                  </el-tree>
                </div>
                <div class="assistBtn">
                  <div class="confirm" @click="assistHandlePopover">完成</div>
                  <div class="reset" @click="resetTree">重置</div>
                </div>
              </div>
              <div class="tagList" slot="reference">
                <el-button
                  type="primary"
                  :loading="assistLoading"
                  :disabled="assistDisabled"
                  >分配</el-button
                >
                <!-- <template v-if="tagList.length > 0">
                  <el-tag v-for="item in tagList" :key="item.id">{{
                    item.name
                  }}</el-tag>
                </template>
                <template v-else>
                  <div class="placeholder">请选择人员</div>
                </template> -->
              </div>
            </el-popover>
            <el-button type="primary" size="small" @click="downPackage"
              >导出MD5排重包</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="visible = true"
              >筛选</el-button
            >
            <el-radio-group
              class="el_radio_group"
              v-model="isNew"
              @input="onFilterChange"
            >
              <el-radio label="">全部</el-radio>
              <el-radio label="1">新客户</el-radio>
              <el-radio label="2">再分配客户</el-radio>
              <el-radio label="3">历史客户</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
      <div class="static_tips" v-if="staticInfo && staticInfo.length">
        <span>您有</span>
        <div class="" v-for="(item, index) in staticInfo" :key="index">
          <span class="underline" @click="setParams(item)">{{
            item.time
          }}</span>
          <span>天以上未跟进客户</span>
          <span>{{ item.num }}人，</span>
        </div>
      </div>
    </div>

    <el-table
      :data="dataList"
      ref="multipleTable"
      style="width: 100%"
      :row-class-name="$getTableClass"
      @selection-change="handleSelectionChange"
      @select="select"
      @select-all="selectAll"
      v-loading="loading"
      element-loading-text="加载中..."
      @sort-change="sortChange"
      :max-height="tableHeight"
      :key="tableHeight"
      v-tabscroll="$getTableHeight"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="客户信息" width="160">
        <template slot-scope="{ row }">
          <tab-user :user="row" :list="dataList" v-if="row"></tab-user>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="age" label="年龄" :width="sortTdWidth">
      </el-table-column> -->
      <el-table-column prop="media" label="媒体" align="center" :width="50">
      </el-table-column>
      <el-table-column label="状态" align="center" :width="sortTdWidth">
        <template slot-scope="{ row }">
          <div class="customStatusBox">
            <div
              class="rect"
              :style="`background:${showFollowProcess(row.progress).colour}`"
              :class="{
                haveBackground: showFollowProcess(row.progress).colour,
              }"
            >
              {{ showFollowProcess(row.progress).desc }}
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="employee.name"
        label="持有人"
        align="center"
        :width="70"
      >
      </el-table-column>
      <!-- <el-table-column label="通话状态" :width="80">
        <template slot-scope="{row}">
          {{PASSOPTIONSSTATUSLIST[row.call]}}
        </template>
      </el-table-column> -->
      <el-table-column label="星级" :width="50">
        <template slot-scope="{ row }">
          <div
            v-for="(item, index) in getStarTagList(row.label)"
            :key="index"
            class="star"
            :class="{ starHaveBack: item.colour }"
            :style="`background:${item.colour}`"
          >
            {{ item.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="条件备注" :width="166">
        <template slot-scope="{ row }">
          <condition-remark :list="getTagList(row.remark, ';')" />
        </template>
      </el-table-column>
      <el-table-column label="跟进记录" :width="250">
        <template slot-scope="scope">
          <el-popover placement="left-end" trigger="hover" width="500">
            <div class="remarkBox">
              <div class="remarkList">
                <div
                  v-for="(item, index) in scope.row.remarkList"
                  :key="index"
                  class="item mb-3"
                >
                  <div class="remark">{{ item.remark }}</div>
                  <div class="createBy pl-3">{{ item.createBy }}</div>
                  <div class="updateDate ml-3">{{ item.updateDate }}</div>
                </div>
              </div>
            </div>
            <div slot="reference" class="remarkList">
              <div
                v-for="(item, index) in scope.row.remarkList"
                :key="index"
                class="item remarkItem"
                :class="{ hide: index > 1 }"
              >
                <div class="remark">{{ cutWordLength(item.remark, "20") }}</div>
                <div class="createBy pl-3">{{ item.createBy }}</div>
                <div class="updateDate ml-3">{{ item.updateDate }}</div>
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="未跟进" :width="80" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.days }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remarkDate"
        label="最后备注日期"
        sortable="remark_date"
        :width="tdWidth"
      />
      <el-table-column
        prop="createDate"
        label="入库时间"
        sortable="create_date"
        :width="tdWidth"
      />
      <el-table-column
        prop="distributeDate"
        label="分配时间"
        sortable="distribute_date"
        :width="tdWidth"
      />
      <el-table-column label="操作" width="170" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="assistHandle(row.id)" size="small"
            >点评</el-button
          >
          <!-- <el-button type="text" @click="getRecordList(row.mobile)" size="small"
            >查看录音</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <BasePagination
      v-model="page"
      :total="totalCount"
      :pageSize="pageSize"
      @change="pageOnChange"
    />
    <el-dialog
      title="点评"
      width="30%"
      :visible.sync="chooseDialogVisi"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-form-item>
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="content"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseDialogVisi = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="assistSubmitLoading"
          @click="assistSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="录音列表"
      width="1200px"
      :visible.sync="dialog.visible"
      :close-on-click-modal="false"
    >
      <el-table :data="dialog.list">
        <el-table-column
          property="employeeName"
          label="员工名称"
          width="100"
        ></el-table-column>
        <el-table-column
          property="employeePhone"
          label="员工手机号码"
          width="150"
        ></el-table-column>
        <el-table-column property="fileUrl" label="录音文件"></el-table-column>
        <el-table-column
          property="createDate"
          label="创建日期"
        ></el-table-column>
        <el-table-column property="name" label="操作" width="360">
          <template slot-scope="{ row }">
            <div class="d-flex">
              <audio
                class="audio mr-2"
                :src="row.fileUrl"
                loop=""
                controlsList="nodownload"
                mutex
                controls
              ></audio>
              <!-- <video controls>
                <source
                :src="row.fileUrl"
                type='video/3gp' />
              </video> -->
              <el-button @click="download(row.fileUrl, name)" type="text"
                >下载</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 跟进弹框 开始 -->
    <glsx-dialog
      title="跟进"
      width="60%"
      :show="showDialog"
      @close="closeDialog()"
    >
      <follow-up
        ref="followUpCom"
        v-if="showDialog"
        :data="selectItem"
        @change="onChange"
      ></follow-up>
      <div slot="footer">
        <el-button
          type="primary"
          size="small"
          :loading="updateLoading"
          @click="updateCustomer()"
          >保存</el-button
        >
        <el-button type="default" size="small" @click="closeDialog()"
          >取消</el-button
        >
      </div>
    </glsx-dialog>
    <!-- 跟进弹框 end -->

    <!-- 分配弹框 开始 -->
    <glsx-dialog
      :show="allotDialog"
      title="分配"
      width="30%"
      @close="closeAllotDialog()"
    >
      <el-form ref="addForm" :model="addForm" label-width="100px">
        <el-form-item label="门店">
          <el-select
            v-model="addForm.shopId"
            @change="shopSelectChange"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shopOptionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团队">
          <el-select
            v-model="addForm.teamId"
            @change="teamSelectChange"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in teamOptionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工">
          <el-select
            v-model="addForm.employeeIdList"
            filterable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in employeeOptionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="small"
          :loading="assistSubmitLoading"
          @click="saveAllotInfo()"
          >保存</el-button
        >
        <el-button type="default" size="small" @click="closeAllotDialog()"
          >取消</el-button
        >
      </div>
    </glsx-dialog>
    <!-- 分配弹框 end -->

    <!-- 导出排重包 -->
    <DownloadPopup v-model="showDownPopup" v-if="showDownPopup" />
  </div>
</template>

<script>
//import Params from "./Params.vue";
import ParamsDialogVue from "@/views/clients-manage/allocated/ParamsDialog.vue";
import {
  allCustomerPage,
  customerComment,
  addPool,
  getRecordList,
  shopList,
  allTeamList,
  getEmployee,
  customerDistribute,
} from "@/api/customer";
import { followUpOptions, startOptions, passOptions } from "./config";
import { mapState } from "vuex";
import FollowUp from "@/components/follow";
import { SEXTYPELIST, PASSOPTIONSSTATUSLIST } from "@/common/constants";
import TabUser from "@/components/user";
import {
  showFollowProcess,
  getTagList,
  getStarTagList,
  received,
} from "@/utils/util";
import {
  GET_CUSTOMER_STATISTICS,
  GET_CUSTOMER_TEAM_STATISTICS,
  GET_TEAM_ALL_CUSTOMER,
} from "@/http/customer";
import DownloadPopup from "@/components/download/index.vue";
import moment from "moment";
import { starOptions } from "@/views/clients-manage/allocated/config";
import { personList } from "@/api/dashboard.js";
export default {
  components: {
    ParamsDialogVue,
    FollowUp,
    TabUser,
    DownloadPopup,
  },
  data() {
    return {
      props: {
        children: "employees",
        label: "name",
      },
      personList: [],
      starOptions,
      fieldList: [],
      page: 1,
      pageSize: 100,
      dataList: [],
      totalCount: 0,
      form: {},
      followUpOptions,
      startOptions,
      passOptions,
      assistDisabled: true,
      chooseDialogVisi: false,
      assistSubmitLoading: false,
      content: "",
      userSelectArr: [],
      dialog: {
        visible: false,
        list: [],
      },
      audiolist: [],
      customerId: "",
      sortTdWidth: 100,
      smallWidth: 110,
      tdWidth: 130,
      longTdWidth: 500,
      showDialog: false,
      selectItem: {},
      SEXTYPELIST,
      PASSOPTIONSSTATUSLIST,
      showFollowProcess: (str) => showFollowProcess(str),
      getTagList: (str, id) => getTagList(str, id),
      getStarTagList: (str, id) => getStarTagList(str, id),
      getStarTagList: (str, id) => getStarTagList(str, id),
      updateLoading: false,
      allotDialog: false,
      shopOptionList: [],
      teamOptionList: [],
      employeeOptionList: [],
      addForm: {},
      loading: false,
      staticInfo: [],
      showDownPopup: false,
      isNew: "",
      tableHeight: 0,
      visible: false,
      assistLoading: false,
    };
  },
  mounted() {
    this.getPersonList();
    this.fieldList = JSON.parse(JSON.stringify(this.fieldList1));
    received("update.success", this.allCustomerPage);
    this.getShopList();
    this.getStatic();
    // 计算表格的高度
    let _this = this;
    this.$getTableHeight();
    window.onresize = function () {
      _this.$getTableHeight();
    };
  },
  computed: {
    ...mapState({
      fieldList1: (state) => state.myClient.fieldList,
    }),
  },
  watch: {
    fieldList1(val) {
      this.fieldList = JSON.parse(JSON.stringify(val));
    },
    "dialog.visible": {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.listenVideo();
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    assistHandle(id) {
      this.customerId = id;
      this.chooseDialogVisi = true;
    },
    getPersonList() {
      personList().then((res) => {
        res.data.forEach((item) => {
          item.employees = item.teamList;
        });
        this.personList = res.data;
      });
    },
    resetTree() {
      this.employeeIdList = [];
      this.tagList = [];
      this.personList.forEach((item) => {
        this.$refs.tree.setChecked(item.id, false, true);
      });
    },
    handleCheckChange(checkedNodes, checkedKeys) {
      console.log(checkedNodes);
      console.log(checkedKeys);
      this.employeeIdList = checkedKeys.checkedKeys;
      this.tagList = checkedKeys.checkedNodes;
    },
    async download(url, name) {
      this.downloadFile(url);
    },
    downloadFile(url) {
      const DownloadLink = document.createElement("a");
      DownloadLink.href = url;
      document.body.appendChild(DownloadLink);
      DownloadLink.click(); // 触发a标签的click事件
      DownloadLink.style = "display: none"; // 创建一个隐藏的a标签
    },

    async getRecordList(mobile) {
      const res = await getRecordList(mobile);
      if (!res.result) return;

      if (!res.data.length) {
        this.$message.error("暂无数据");
        return;
      }

      this.dialog.list = res.data;
      this.dialog.visible = true;
    },
    listenVideo() {
      this.audiolist = document.querySelectorAll("audio");
      this.audiolist.forEach((item) => {
        item.addEventListener("play", (e) => {
          this.pauseAll(e.target);
        });
      });
    },
    pauseAll(target) {
      this.audiolist.forEach((item) => {
        target !== item && item.pause();
      });
    },
    async allCustomerPage(form) {
      this.showAppLoading();
      try {
        this.loading = true;
        await GET_TEAM_ALL_CUSTOMER({
          page: this.page,
          size: this.pageSize,
          paramObject: { ...form },
        }).then((res) => {
          this.loading = false;
          const { data } = res;
          this.dataList = data.dataList || [];
          this.totalCount = data.totalCount;
          this.$nextTick(() => {
            let index = 0;
            const list = document.querySelectorAll("tr");
            const tbody = document.querySelector("tbody");
            const comment = tbody.getElementsByClassName("comment");
            if (!comment) {
              return false;
            }
            for (let index1 = comment.length - 1; index1 >= 0; index1--) {
              const element = comment[index1];
              element.remove();
            }
            list.forEach((dom) => {
              if (dom.classList.contains("el-table__row")) {
                if (this.dataList[index] && this.dataList[index].comment) {
                  const div = document.createElement("div");
                  div.innerHTML = `主管点评：${this.dataList[index].comment}`;
                  div.classList.add("comment");
                  dom.parentNode.insertBefore(div, dom);
                }
                index++;
              }
            });
          });
        });
        this.hideAppLoading();
      } catch (error) {
        this.hideAppLoading();
      }
    },
    pageOnChange(row) {
      console.log(row);
      this.page = row.page;
      if (row.pageSize) {
        this.pageSize = row.pageSize;
      }
      this.$refs.params.search();
    },

    handleSelectionChange(e) {
      this.assistDisabled = e.length === 0;
      this.idArr = e.map((element) => element.id);
    },
    select(selection, row) {
      // if (selection.length > 1) {
      //   const del_row = selection.shift()
      //   this.$refs.multipleTable.toggleRowSelection(del_row, false)
      // }
    },
    selectAll(selection) {
      // if (selection.length > 1) {
      //   selection.length = 1
      // }
    },
    async assistHandlePopover() {
      this.assistLoading = true;
      try {
        const form = {
          idList: this.idArr,
          shopId: this.shopId,
          teamId: this.teamId,
          employeeIdList: this.employeeIdList,
          distribute: 1,
        };
        await customerDistribute(form).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.chooseDialogVisi = false;
            this.$refs.params.search();
            this.$refs.popover.doClose();
          }
        });
      } finally {
        this.assistLoading = false;
      }
    },
    async assistSubmit() {
      this.assistSubmitLoading = true;
      try {
        const form = {
          // customerId: this.idArr[0],
          customerId: this.customerId,
          content: this.content,
        };
        await customerComment(form).then((res) => {
          this.$message.success(res.message);
          this.content = "";
          this.chooseDialogVisi = false;
          this.$refs.params.search();
        });
        this.assistSubmitLoading = false;
      } catch (error) {
        this.assistSubmitLoading = false;
      }
    },
    joininPublicPool() {
      this.$confirm(`确认加入公共池?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "请求中...";
            try {
              // await addPool({ id: this.idArr[0] }).then(res => {
              await addPool({ idList: this.idArr }).then((res) => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              });
              done();
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "确定";
              this.$refs.params.search();
            } catch (error) {
              done();
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "确定";
            }
          } else {
            done();
          }
        },
      });
    },

    // 保存跟进数据
    updateCustomer() {
      this.updateLoading = true;
      this.$refs.followUpCom.saveInfo();
    },

    // 关闭弹框
    closeDialog() {
      this.showDialog = false;
      this.customerPublicPage();
    },

    // 监听组件变化
    onChange(e) {
      this.updateLoading = false;
      if (e) {
        this.closeDialog();
      }
    },

    // 打开跟进弹框
    followUpHandle(item) {
      this.selectItem = Object.assign({}, item);
      this.showDialog = true;
    },

    // 展示条件备注
    showRemark(str) {
      if (!str) {
        return [];
      }
      let m = str.split(";");
      return m;
    },

    // 打开分配弹框
    allotEvent() {
      this.allotDialog = true;
    },

    // 关闭分配弹框
    closeAllotDialog() {
      this.allotDialog = false;
      this.addForm = {};
    },

    // 获取门店列表
    getShopList() {
      shopList({ type: 1 }).then((res) => {
        this.shopOptionList = res.data;
      });
    },

    // 获取团队列表
    async shopSelectChange() {
      let o = this.addForm;
      if (o.teamId) {
        delete o.teamId;
      }
      if (o.employeeIdList) {
        delete o.employeeIdList;
      }
      await allTeamList({ shopId: o.shopId, type: 1 }).then((res) => {
        this.teamOptionList = res.data;
      });
    },

    // 获取员工列表
    async teamSelectChange() {
      let o = this.addForm;
      if (o.employeeIdList) {
        delete o.employeeIdList;
      }
      await getEmployee({
        shopId: o.shopId,
        teamId: o.teamId,
        type: 1,
      }).then((res) => {
        this.employeeOptionList = res.data || [];
      });
      this.employeeSelectLoading = false;
    },

    // 分配客户
    saveAllotInfo() {
      this.assistSubmitLoading = true;
      let oParams = JSON.parse(JSON.stringify(this.addForm));
      oParams.idList = this.idArr;
      customerDistribute(oParams).then((res) => {
        this.assistSubmitLoading = false;
        if (res.code === 200) {
          this.$message.success(res.message);
          this.$refs.params.search();
          this.closeAllotDialog();
        }
      });
    },

    // 获取未跟进客户统计
    getStatic() {
      let form = this.$refs.params.form;
      let params = { ...form };
      GET_CUSTOMER_TEAM_STATISTICS(params).then((res) => {
        let obj = res.data || {};
        let arr = [];
        for (let k in obj) {
          arr.push({ time: k, num: obj[k] });
        }
        this.staticInfo = arr || [];
        this.$nextTick(() => {
          this.$getTableHeight();
        });
      });
    },

    // 设置参数
    setParams(row) {
      this.$refs.params.setParams("followDayCount", row.time);
      this.$refs.params.search();
    },

    // 导出MD5 重排包
    downPackage() {
      this.showDownPopup = true;
    },

    // 监听表格排序
    sortChange({ column, prop, order }) {
      console.log(column);
      //this.formInline.orderField = prop;
      let str = `${column.sortable} asc`;
      if (order == "ascending") {
        str = `${column.sortable} asc`;
      } else {
        str = `${column.sortable} desc`;
      }
      this.$refs.params.setParams("sort", str);
      this.$refs.params.search();
      //this.getList();
    },

    // 是否新用户
    isNewUser(row) {
      let _name = "";
      let isTrue = moment().isSame(row.createDate, "day");
      if (isTrue) {
        _name = "current_user";
      }
      return _name;
    },

    // 筛选客户
    onFilterChange(e) {
      this.$refs.params.setParams("isNew", e);
      this.$refs.params.search();
    },

    // 搜索客户
    onSearch(form) {
      this.allCustomerPage(form);
      this.getStatic();
    },

    //
    getPlayerOptions(row) {
      let options = {
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        sources: [
          {
            type: "application/x-mpegURL", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: row.fileUrl, // url地址
          },
        ],
        hls: true,
        poster: "", // 你的封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      };
      return options;
    },
  },
};
</script>

<style lang="scss">
.NewCustomer {
  padding: 20px;
}

.txt {
  padding: 8px 0;
}

.wrapping {
  margin-right: 10px;
  margin-bottom: 10px;
}

.btn {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.current_user {
  .name {
    span {
      color: #f00;
    }
  }
}

.el_radio_group {
  margin-left: 10px;
}
</style>
